import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

// Import the generated route tree
import { FullScreenLoader } from "./routes/__root";
import { routeTree } from "./routeTree.gen";

import "./index.css";

// Create a new router instance. A route still fetching its code or data shows
// a spinner after 150ms rather than the default full second.
const router = createRouter({
  routeTree,
  defaultPendingMs: 150,
  defaultPendingComponent: () => <FullScreenLoader message="Loading…" />,
});
const queryClient = new QueryClient();

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("root")!;

if (!rootElement.innerHTML) {
  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
